<template>
    <div class="mt-6 ml-6">Event data: {{ eventdata }}</div>
</template>

<script>
    export default {

        data() {
            return {
                eventdata: ''
            }
        },

        mounted() {

            Echo.channel('media-processing-tracker')
                .listen('MediaFinishedProcessing', (e) => {
                    console.log('NOTIFICATION RECEIVED! Media has finished processing!!!');
                    console.log('Received "e": ' + JSON.stringify(e));
                    this.eventdata = 'We just received notification that this is indeed done!';
                });

        }
    }
</script>
